/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from '@ducky/plumage/loader';
defineCustomElements();
export const PlmgAvatar = /*@__PURE__*/ createReactComponent('plmg-avatar');
export const PlmgButton = /*@__PURE__*/ createReactComponent('plmg-button');
export const PlmgCard = /*@__PURE__*/ createReactComponent('plmg-card');
export const PlmgDropdown = /*@__PURE__*/ createReactComponent('plmg-dropdown');
export const PlmgDropdownItem = /*@__PURE__*/ createReactComponent('plmg-dropdown-item');
export const PlmgErrorMessage = /*@__PURE__*/ createReactComponent('plmg-error-message');
export const PlmgHeader = /*@__PURE__*/ createReactComponent('plmg-header');
export const PlmgPageContainer = /*@__PURE__*/ createReactComponent('plmg-page-container');
export const PlmgRadioButton = /*@__PURE__*/ createReactComponent('plmg-radio-button');
export const PlmgRadioButtonGroup = /*@__PURE__*/ createReactComponent('plmg-radio-button-group');
export const PlmgSeparator = /*@__PURE__*/ createReactComponent('plmg-separator');
export const PlmgSidebar = /*@__PURE__*/ createReactComponent('plmg-sidebar');
export const PlmgSidebarItem = /*@__PURE__*/ createReactComponent('plmg-sidebar-item');
export const PlmgSlider = /*@__PURE__*/ createReactComponent('plmg-slider');
export const PlmgStatus = /*@__PURE__*/ createReactComponent('plmg-status');
export const PlmgSvgIcon = /*@__PURE__*/ createReactComponent('plmg-svg-icon');
export const PlmgTab = /*@__PURE__*/ createReactComponent('plmg-tab');
export const PlmgTabs = /*@__PURE__*/ createReactComponent('plmg-tabs');
export const PlmgTextInput = /*@__PURE__*/ createReactComponent('plmg-text-input');
export const PlmgTooltip = /*@__PURE__*/ createReactComponent('plmg-tooltip');
//# sourceMappingURL=components.js.map